<template>
	<v-card outlined class="mr-2">
		<v-card-title>
			<div style="width: 100%;">{{ title }}</div>
			%
			<v-switch
				v-model="is_value"
				class="ml-2"
				label=""
				:disabled="loading"/>
			Стойности
		</v-card-title>
		<v-card-text>
			<transfer-device-list v-if="is_value" :loading="loading" :row="row" :field="field"/>
			<old-new-rate-input v-else :loading="loading" :field="field" :row="row"/>
		</v-card-text>
	</v-card>
</template>

<script>

import TransferDeviceList from "./TransferDeviceList.vue";
import OldNewRateInput from "@/views/custom_imot_ownership_transfer/OldNewRateInput.vue";

export default {
	components: {
		OldNewRateInput,
		TransferDeviceList,
	},
	props: [
		'err',
		'row',
		'loading',
		'title',
		'field',
	],
	data() {
		return {
			is_value: null,
		}
	},
	watch: {
		row: {
			deep: true,
			handler(newValue, oldValue) {
				if(this.is_value !== null) {
					return;
				}
				if (newValue && oldValue && newValue[this.field] === oldValue[this.field]) {
					return;
				}
				this.is_value = Object.keys(this.row.devices_transfer_data[this.field]).length > 0;
			},
		},
	},
}
</script>